import { Speech } from './SpeechModule';

export class SpeechOptions {
    public speechRecognizer: Speech.ISpeechRecognizer;
    public speechSynthesizer: Speech.ISpeechSynthesizer;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/SpeechOptions.ts